document.addEventListener("DOMContentLoaded", () => {
  // --- Mobile Menu ---
  function toggleMenu() {
    const burger = document.querySelector(".js-burger");
    const menu = document.querySelector(".js-header-nav");
    const body = document.body;

    if (!burger || !menu) return;

    burger.addEventListener("click", () => {
      menu.classList.toggle("active");
      burger.classList.toggle("active");
      body.classList.toggle("locked");
    });

    window.addEventListener("resize", () => {
      if (window.innerWidth > 992) {
        menu.classList.remove("active");
        burger.classList.remove("active");
        body.classList.remove("locked");
      }
    });
  }
  toggleMenu();

  // --- Scroll Reveal ---
  function initScrollReveal() {
    const makeObserver = (threshold = 0.1) =>
      new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-visible");
              obs.unobserve(entry.target);
            }
          });
        },
        { threshold },
      );

    // Sections fade-in
    const sectionObs = makeObserver(0.1);
    document.querySelectorAll(".scroll-show").forEach((el) => sectionObs.observe(el));

    // Card rows — reveal triggers staggered CSS nth-child delays
    const rowObs = makeObserver(0.1);
    [".count-row", ".growth__row", ".team-cards", ".inside__row", ".about__row", ".work-row"].forEach((sel) => document.querySelectorAll(sel).forEach((el) => rowObs.observe(el)));
  }
  initScrollReveal();

  // --- Number counters ---
  function initCounters() {
    const obs = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        entry.target.querySelectorAll(".number[data-count]").forEach(el => {
          const target = parseFloat(el.dataset.count);
          if (isNaN(target)) return;
          const isFloat = !Number.isInteger(target);
          const duration = 1400;
          const startTime = performance.now();
          function tick(now) {
            const progress = Math.min((now - startTime) / duration, 1);
            const ease = 1 - Math.pow(1 - progress, 3);
            el.textContent = isFloat ? (target * ease).toFixed(1) : Math.round(target * ease);
            if (progress < 1) requestAnimationFrame(tick);
            else el.textContent = isFloat ? target.toFixed(1) : String(target);
          }
          requestAnimationFrame(tick);
        });
      });
    }, { threshold: 0.1 });

    document.querySelectorAll(".partner-row, .count-row").forEach(el => obs.observe(el));
  }
  initCounters();

  // --- Popup ---
  function initPopup() {
    const popup = document.getElementById("popup-diagnostic");
    if (!popup) return;

    const closeBtn = document.getElementById("closePopup");
    const backdrop = popup.querySelector(".popup-backdrop");

    function openPopup() {
      popup.classList.add("is-active");
      document.body.classList.add("locked");
    }

    function closePopup() {
      popup.classList.remove("is-active");
      document.body.classList.remove("locked");
    }

    document.querySelectorAll('[data-popup="popup-diagnostic"]').forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        openPopup();
      });
    });

    closeBtn?.addEventListener("click", closePopup);
    backdrop?.addEventListener("click", closePopup);

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && popup.classList.contains("is-active")) closePopup();
    });
  }
  initPopup();

  // --- Select2 ---
  jQuery(".popup-modal select").select2({
    placeholder: "Questions about a recent briefing",
    allowClear: false,
    minimumResultsForSearch: Infinity,
    dropdownParent: jQuery(".popup-modal"),
  });

  // --- Smooth Scroll ---
  const scrollToEl = (el) => {
    const top = el.getBoundingClientRect().top + window.pageYOffset - 70;
    window.scrollTo({ top, behavior: "smooth" });
  };

  const closeMenu = () => {
    const burger = document.querySelector(".js-burger");
    const menu = document.querySelector(".js-header-nav");
    burger?.classList.remove("active");
    menu?.classList.remove("active");
    document.body.classList.remove("locked");
  };

  // Same-page anchor links
  document.querySelectorAll('a[href*="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      const url = new URL(this.href, window.location.href);
      if (!url.hash || url.origin !== window.location.origin) return;
      const samePage = url.pathname.replace(/\/$/, "") === window.location.pathname.replace(/\/$/, "");
      if (!samePage) return; // let browser navigate; hash-on-load handles scroll
      const target = document.querySelector(url.hash);
      if (!target) return;
      e.preventDefault();
      closeMenu();
      scrollToEl(target);
    });
  });

  // Cross-page: arrived with a hash (e.g. from inner page → /#about)
  if (window.location.hash) {
    const target = document.querySelector(window.location.hash);
    if (target) {
      history.scrollRestoration = "manual";
      window.scrollTo(0, 0);
      setTimeout(() => scrollToEl(target), 300);
    }
  }
});
